// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD6M-emMrro9R1ZCHBfPVCbiqdrAe4CD-I",
  authDomain: "smallseobusiness.firebaseapp.com",
  projectId: "smallseobusiness",
  storageBucket: "smallseobusiness.firebasestorage.app",
  messagingSenderId: "396313557645",
  appId: "1:396313557645:web:7affaf232841422a3bc0c4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;